module.exports = __webpack_public_path__ + "img/open_status.ac5ed5c5.svg";